import { render, staticRenderFns } from "./KnowledgeCenterView.vue?vue&type=template&id=d081fba0&scoped=true&"
import script from "./KnowledgeCenterView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCenterView.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeCenterView.vue?vue&type=style&index=0&id=d081fba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d081fba0",
  null
  
)

export default component.exports